import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function F() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('save_electric');

    return (
        <div className={`save-electric-f ${css.SaveElectricF}`}>
            <section className="section-a text-wrapper">
                <div className="left">
                    <h2 className="sub-title">{t('sec_8_subtitle')}</h2>
                    <p className="title">{t('sec_8_title')}</p>
                </div>
                <p className="right desc">{t('sec_8_desc')}</p>
            </section>
            <section className="section-b">
                <NextImage
                    webpSrc="https://websiteoss.ecoflow.com/upload/image/1730190462100/jp-soeb-img.jpg"
                    src="https://websiteoss.ecoflow.com/upload/image/1730190462100/jp-soeb-img.jpg"
                    alt={t('sec_9_title1')}
                    aria-label={t('sec_9_title1')}
                />
                <div className="box">
                    <p className="title">{t('sec_9_title1')}</p>
                    <p className="desc">{t('sec_9_desc1')}</p>
                    <Link
                        className="learn-more"
                        href="https://jp.ecoflow.com/products/ecoflow-220w-solarpanel-new"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: t('sec_9_title1'),
                            position: 'Electricity Saving',
                        }}
                    >
                        {t('btn')}
                    </Link>
                </div>
                <div className="box box-2">
                    <p className="title">{t('sec_9_title2')}</p>
                    <p className="desc">{t('sec_9_desc2')}</p>
                    <Link
                        className="learn-more"
                        href="https://jp.ecoflow.com/products/400w-solar-panel"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: t('sec_9_title2'),
                            position: 'Electricity Saving',
                        }}
                    >
                        {t('btn')}
                    </Link>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/save-electric/pc/9-2.webp')}
                    src={require('@publicLocal/save-electric/pc/9-2.jpg')}
                    alt={t('sec_9_title2')}
                    aria-label={t('sec_9_title2')}
                />
            </section>
            <p className="section-c">{t('sec_9_text')}</p>
        </div>
    );
}
